import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CaseCreateForm from "forms/case-create";
import { Row, Col, Card, Button, Result, Modal, Tabs, message } from "antd";
import { Table } from "components/table";
import { CaseEntryRecord } from "records";
import { createCase, resetCaseCreate, createBulkAdhocCase, createBulkPayProCase } from "store/actions";
import { STATE_STATUS } from "constants/index";
import CompanyService from "services/company-service";
import { List, Map } from "immutable";
import { PREVIOUSLY_CREATED_CASE_COLS } from "constants/table-columns";
import AdhocCaseForm from "forms/adhoc-case-form";
import PaymentProgramForm from "forms/payment-program-form";
import "styles/case-create.css";
class NewCaseCreate extends React.Component {

    state = {
        casesList: [],
        resetGST: false,
        isPreviouslyCreatedCase: false,
        activeTabKey: "case-create",
        sales_manager_users: null,
        lending_partners: null,
        insideSalesPersonolleData: null,
    };
    
    formRef = React.createRef();
    onSubmit = () => {
        this.formRef.current.validateFields((err, values) => {
            if(!err) {
                const contact_detail = {
                    first_name: values.first_name,
                    last_name: values.last_name,
                    email: values.email,
                    phone: values.phone,
                    nature_of_association: values.nature_of_association,
                    gender: values.gender
                };
                this.props.createCase(new CaseEntryRecord(values), contact_detail);
            }
        });
    }

    componentDidMount() {
        if(!this.state.sales_manager_users) {
            CompanyService.getSMList().then(({data}) => {
                this.setState({
                    sales_manager_users: data
                });
            }).catch(() => {});
        }
        if(!this.state.lending_partners) {
            CompanyService.getLendingPartners().then(({data}) => {
                this.setState({
                    lending_partners: data
                });
            }).catch(() => {});
        }
        CompanyService.getISPList().then(({data})=>this.setState({insideSalesPersonolleData:data}))
            .catch(() => {
                message.error("Something went wrong");
            });
    }

    resetCaseCreate = () => {
        this.setState({
            resetGST: true
        }, () => {
            this.props.resetCaseCreate();
        });
    }

    renderCaseSuccessScreen() {
        if(this.props.case.status === STATE_STATUS.CREATED) {
            this.formRef && this.formRef.current && this.formRef.current.resetFields();
            return(
                <Col className={"pos-abs w-100 h-100 bg-white z-top"}>
                    <Result
                        status="success"
                        title="Case Created"
                        extra={[
                            <Button type="primary" key="console" onClick={this.resetCaseCreate}>
                                Add Another Case
                            </Button>,
                        ]}
                    />
                </Col>);
        }
        return  null;
        
    }

    showGstinDetails = (values, validatorCallback, resetCallBack) => {
        if(values && values.length) {
            const modal = Modal.confirm();
            modal.update({
                title: "Cases Already created By Same GSTIN",
                content: (<Table
                    className={"padless-table"}
                    showTopSection={false}
                    noRowSelection={true}
                    columns={PREVIOUSLY_CREATED_CASE_COLS}
                    data={new List(values)}
                />),
                onOk:() => {
                    modal.destroy();
                    validatorCallback();
                },
                onCancel: () => {
                    if(!this.formRef.current) {
                        modal.destroy();
                        return;
                    }
                    resetCallBack();
                    this.formRef.current.resetFields();
                },
                okText: "Proceed with Case Create",
                cancelText: "Reset",
                width: 1000
            });
        } else {
            validatorCallback();
        }
    }

    onTabChange = (key) => {
        this.setState({
            activeTabKey: key
        });
    }

    render() {
        return (
            <React.Fragment>
                <Row className={"p-5"}>
                    <Col className={"p-5"} offset={3} span={18}>
                        <Tabs defaultActiveKey={this.state.activeTabKey} className={"list-view"}>
                            {/* <Tabs.TabPane key={"case-create"} tab={"New Case Create"}>
                                <Card>
                                    <Row>
                                        {this.renderCaseSuccessScreen()}
                                        <Col>
                                            <CaseCreateForm
                                                resetGST={this.state.resetGST}
                                                ref={this.formRef}
                                                values={this.props.case}
                                                applicantDetails={this.props.applicantDetails}
                                                showGstinDetails={this.showGstinDetails}
                                                fromCaseCreate={true}
                                                errors={new Map(this.props.errors)}
                                            />
                                        </Col>
                                        <Col className={"d-flex flex-row-reverse mt-10"}>
                                            <Button type={"primary"} onClick={this.onSubmit}>Create</Button>
                                            <Button className={"mr-5"} onClick={() => this.props.history.goBack()}>Cancel</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </Tabs.TabPane>*/}
                            <Tabs.TabPane key={"adhoc"} tab={"Adhoc/Enhancement"}>
                                <Card>
                                    <Row>
                                        <Col>
                                            {this.state.sales_manager_users && this.state.insideSalesPersonolleData && 
                                            <AdhocCaseForm
                                                status={this.props.bulkCaseCreasteStatus}
                                                lending_partners={this.state.lending_partners}
                                                sales_manager_users={this.state.sales_manager_users}
                                                createBulkAdhocCase={this.props.createBulkAdhocCase}
                                                insideSalesPersonolleData={this.state.insideSalesPersonolleData}
                                            />
                                            }
                                        </Col>
                                    </Row>
                                </Card>
                            </Tabs.TabPane> 
                            <Tabs.TabPane key={"paypro"} tab={"Payment Program"}>
                                <Card>
                                    <Row>
                                        <Col>
                                            <PaymentProgramForm
                                                status={this.props.bulkPayProStatus}
                                                createBulkPayProCase={this.props.createBulkPayProCase}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Tabs.TabPane>
                        </Tabs>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

NewCaseCreate.propTypes = {
    case: PropTypes.object,
    createCase: PropTypes.func,
    resetCaseCreate: PropTypes.func,
    history: PropTypes.object,
    createBulkAdhocCase: PropTypes.func,
    createBulkPayProCase: PropTypes.func,
    applicantDetails: PropTypes.object,
    bulkCaseCreasteStatus: PropTypes.string,
    errors: PropTypes.object,
    bulkPayProStatus: PropTypes.string
};

const mapDispatchToProps = dispatch => bindActionCreators({
    createCase,
    resetCaseCreate,
    createBulkAdhocCase,
    createBulkPayProCase
}, dispatch);

const mapStateToProps = state => ({
    status: state.caseCreate.get("status"),
    bulkCaseCreasteStatus: state.caseCreate.getIn(["bulkAdhocCases", "status"]),
    bulkPayProStatus: state.caseCreate.getIn(["bulkPayProCases", "status"]),
    case: state.caseCreate.get("case"),
    applicantDetails: state.caseCreate.get("applicant_details"),
    errors: state.caseCreate.get("errors")
});

export default connect(mapStateToProps, mapDispatchToProps)(NewCaseCreate);